import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {WorkPermitRuleForm} from "./WorkPermitRuleForm";

export const WorkPermitRuleEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <WorkPermitRuleForm />
    </DefaultEdit>
  );
};
